import defaultConfig  from '../config/defaults';
import axios from 'axios';
declare const window: any;
export class Utils {

    static isInViewport(el: HTMLElement): boolean{
        if (el) {
            const rect = el.getBoundingClientRect();
            let inViewFlag = (
                rect.top >= -250 &&
                rect.left >= 0 &&
                rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) + 250 &&
                rect.right <= window.innerWidth + document.documentElement.clientWidth
            );
            return inViewFlag;
        } else {
            return false;
        }

    }

    static getScriptParams(): object {
        let allScriptTags = document.currentScript;
        let pa = allScriptTags.attributes['src']['value'].split("?").pop().split("&");

        // Split each key=value into array, the construct js object

        let p = {};
        for(let j=0; j<pa.length; j++) {
            let kv = pa[j].split("=");
            p[kv[0]] = kv[1];
        }
        return p;
    }

    static getDeviceUserAgent(): object {
        try{
            if (navigator.userAgent.match(/Tablet|iPad/i))
            {
                return { userAgent: 'tablet', carousalTiles: defaultConfig.carousalTiles.tablet};
            } else if(navigator.userAgent.match(/Mobile|Windows Phone|Lumia|Android|webOS|iPhone|iPod|Blackberry|PlayBook|BB10|Opera Mini|\bCrMo\/|Opera Mobi/i) )
            {
                return { userAgent :'mobile', carousalTiles: defaultConfig.carousalTiles.mobile};
            } else {
                return { userAgent: 'desktop', carousalTiles: defaultConfig.carousalTiles.desktop};
            }
        } catch (e) {
            console.log("error", e);
        }
    }

    static setDataDirAttribute(locale: string, element: HTMLElement){
        if(defaultConfig.rtlLocales.indexOf(locale)>=0){
            (document.body as HTMLElement).setAttribute('data-dir', 'true');
        }
    }

    static getPageNumber() {
        let splittedQueryParams = location.search.toLowerCase().split("?").pop().split("&");
        // Split each key=value into array, the construct js object
        let p = {};
        let page;
        for (let j = 0; j < splittedQueryParams.length; j++) {
            let kv = splittedQueryParams[j].split("=");
            p[kv[0]] = kv[1];
        }
        if (p.hasOwnProperty('kqstate')) {
            page = p['kqstate'].split(":")[1]
        } else {
            page=0
        }
        return page;
    }

    static randomStr(len, arr) {
        let ans = '';
        for (let i = len; i > 0; i--) {
            ans +=
                arr[Math.floor(Math.random() * arr.length)];
        }
        return ans;
    }

    /* This function is used to get Login V2 user information form client storage */
    static getLoginUserClientData() {
        let userData = [];
        //Get email from cookies
        let useremail, cookieStart, cookieEnd, cookieName = '_ulcogid';
        if (document.cookie.length > 0) {
            cookieStart = document.cookie.indexOf(cookieName + '=');
            if (cookieStart !== -1) {
                cookieStart = cookieStart + cookieName.length + 1;
                cookieEnd = document.cookie.indexOf(';', cookieStart);
                if (cookieEnd === -1) {
                cookieEnd = document.cookie.length;
                }
                useremail = document.cookie.substring(cookieStart, cookieEnd);
            }
        }
        useremail = useremail ? decodeURIComponent(window.atob(useremail || '')) : '';
        if (typeof(Storage) !== "undefined" && localStorage.getItem("UnileverUserProfileData")) {
            let localStoreData = JSON.parse(localStorage.getItem("UnileverUserProfileData"));
            if (localStoreData && localStoreData.profileAttrs) {
                userData = localStoreData.profileAttrs;
            }
        }
        userData['email'] = useremail;
        return userData;
    }
    
    static getUserOneTrustConsent(consentType: string){
        let decodedCookie = decodeURIComponent(document.cookie), cookieConsentId = '';
        if (decodedCookie.length) {
            let cookieName = 'OptanonConsent',
            cStart = decodedCookie.indexOf(cookieName + '=');
            if (cStart !== -1) {
                cStart = cStart + cookieName.length + 1;
                let cEnd = decodedCookie.indexOf(';', cStart);
                if (cEnd === -1) {
                    cEnd = decodedCookie.length
                }
                let concentData = decodedCookie.substring(cStart, cEnd);
                let cookieConsentStatus = concentData.indexOf(consentType + ':');
                let cIdStart = concentData.indexOf('consentId=');
                if (cIdStart !== -1) {
                    cIdStart = cIdStart + 'consentId='.length;
                    let cIdEnd = concentData.indexOf('&', cIdStart);
                    if (cIdEnd === -1) {
                        cIdEnd = concentData.length
                    }
                    let consentId = concentData.substring(cIdStart, cIdEnd);

                    if (concentData.charAt(cookieConsentStatus + 6) == '1' && consentId) {
                        cookieConsentId = consentId;
                        return cookieConsentId;
                    }
                }
            }
        }
        return cookieConsentId;
    }
    static getadChoiceConsent() {
        const adChoiceConsentData = window.evidon?.notice?.getConsentData();
        let getConsent = false
        if(adChoiceConsentData){
            getConsent = Utils.getAdvertisingAnalyticsValue(adChoiceConsentData.value.categories);
        }
        
        return getConsent ? adChoiceConsentData.name : null
        
    }
    static getAdvertisingAnalyticsValue(categories) {
        for (let key in categories) {
            if (categories[key].hasOwnProperty("advertising & analytics")) {
                return categories[key]["advertising & analytics"];
            }
        }
        return null; // or handle the case where the value doesn't exist
    }

    /* This function is used to get Login V2 user information form V3 API */
    static getLoginUserApiData(loginApiRequest: Object) {
        return new Promise((resolve, reject) =>{
            let userData = this.getLoginUserClientData(),
            userToken = localStorage.getItem("idToken"),
            language = loginApiRequest['locale'].split("-")[0],
            country = loginApiRequest['locale'].split("-")[1].toUpperCase();
            if (userData['email'] && userToken && loginApiRequest['v3_x_api_key']) {
                try {
                    axios({
                        method: 'post',
                        url: loginApiRequest['V3_API_URL'] + '/profile/retrieve/v2',
                        headers: {
                            'authorization': 'Bearer ' + userToken,
                            'x-api-key': loginApiRequest['v3_x_api_key'],
                            'Access-Control-Allow-Origin': "https://showcase-eu-rel.unileversolutions.com",
                            'Access-Control-Allow-Credentials': 'true'
                        },
                        data: { "profile": { "header": { "isoLanguage": language, "isoCountry": country, "brandCode": loginApiRequest['brand'] }, "profileStores": ["ALL"], "extendedProfileStoreGroups": ["ALL"] } },
                    }).then(async (response) => {
                        if (response['data']['profile'] && response['data']['profile']) {
                            userData['profile'] = response['data']['profile'];
                        }
                        resolve(userData);
                    }).catch((error) => {
                        console.error(error);
                        resolve(userData);
                    });
                } catch (error) {
                    console.error(error);
                    resolve(userData);
                }
            } else {
                resolve(userData);
            }
        })
    }
}